import styled from 'styled-components';

interface ContainerProps {
  $bgColor?: string;
  $padding?: string;
}

export const Section = styled.section<ContainerProps>`
  width: 100%;
  padding: ${({ $padding }) => $padding || '3.5rem 2rem'};
  background-color: ${({ $bgColor, theme }) => $bgColor || theme.colors.cream};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ $padding }) => $padding || '2.9rem 1rem'};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ $padding }) => $padding || '4rem 2rem'};
  }
`;

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryDark};
  text-align: center;
  margin-bottom: 0.75rem;
  animation: fadeInUp 0.6s ease forwards;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.textMuted};
  text-align: center;
  margin-bottom: 1.5rem;
  max-width: 44ch;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.55;
  animation: fadeInUp 0.6s ease 0.1s forwards;
  opacity: 0;
  animation-fill-mode: forwards;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    line-height: 1.45;
    max-width: 35ch;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.05rem;
  }
`;

